<div  [style.left.px]="x" [style.top.px]="y" class="context-menu"  >
    <div *ngFor="let item of items" (click)="onItemClick(item)">
        <button>{{item.name}}</button></div>
</div>
